import React from "react";
import { FaSearch } from "react-icons/fa";

export default function DynamicNavBar({ items = [], showSearch = true }) {


  
  return (
    <div className="bg-primaryColor-shade6 mt-16 md:mt-5 mx-12 md:mx-0  px-3 md:px-0 py-2 rounded-md flex items-center justify-between md:w-11/12  md:flex-col md:gap-y-4 md:py-4">
      <div className="flex gap-7">

        {items.map((item, index) => (
          <div key={index} className={`flex items-center md:text-[10px] ${ item.value && item.status && (item.value === item.status) ? `text-baseColor-blue` : null } gap-1 hover:cursor-pointer`} onClick={item?.func}>
            {item.icon}
            {item.label}
          </div>
        ))}
      </div>

      <div className="flex items-center bg-white rounded-md">
        <input
          className="outline-none pr-2 text-right rounded-r-md"
          placeholder="... جست و جو"
        />
        <div className="bg-BlueColor-shade5 text-white p-[5px] rounded-l-md">
          <FaSearch />
        </div>
      </div>

    </div>
  );
}
